import { ComponentIds } from '@inter-ikea-core/core';
import { NightLightsSystem } from '@inter-ikea-storageone/range';
import { darkScene } from 'ducks/layout';
import { BehaviorParameters } from 'rangeConfig/@types';

const enableNightModeBehavior = ({ coreApi, dispatch }: BehaviorParameters) => {
  const currentLightsInScene = coreApi.entities.getByComponent(ComponentIds.LIGHT_COMPONENT_ID);

  if (currentLightsInScene.length > 0) {
    dispatch(darkScene());
    coreApi.getSystem<NightLightsSystem>('NightLightsSystem')?.enable();
  }
};

export default enableNightModeBehavior;
